import script from "./TiptapEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./TiptapEditor.vue?vue&type=script&lang=ts&setup=true"

import "./TiptapEditor.vue?vue&type=style&index=0&id=75209898&scoped=true&lang=scss"
import "./TiptapEditor.vue?vue&type=style&index=1&id=75209898&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75209898"]])

export default __exports__